import { showErrorToast } from "@src/appV2/lib/Notifications";
// eslint-disable-next-line no-restricted-imports -- Bridge to old app code
import { signInWithEmailAndPassword } from "@src/containers/enter/firebase";
// eslint-disable-next-line no-restricted-imports -- Bridge to old app code
import { getErrorMessage } from "@src/utils/errors";

interface LoginWithEmailAndPasswordParams {
  email: string;
  password: string;
}

/**
 * Handles Firebase email/password authentication for mobile
 * This keeps the mobile component clean and isolated
 */
export async function loginWithEmailAndPassword({
  email,
  password,
}: LoginWithEmailAndPasswordParams): Promise<boolean> {
  try {
    const result = await signInWithEmailAndPassword(email, password);
    if ("error" in result && typeof result.error === "string") {
      showErrorToast(result.error);
      return false;
    }

    return true;
  } catch (error: unknown) {
    const message = String(getErrorMessage(error));
    showErrorToast(message);
    return false;
  }
}
